import { useMemo } from 'react';
import uniqBy from 'lodash.uniqby';
import type { ComboboxMultipleProperties } from '@src/components/input/ComboboxMultiple';

type UseAllOptionsParams<T> = Pick<
  ComboboxMultipleProperties<T>,
  'disableSort' | 'options' | 'displayValue' | 'sortFn'
> & { addedOptions: T[] };

export function useAllOptions<T>({
  disableSort,
  options = [],
  displayValue,
  sortFn,
  addedOptions,
}: UseAllOptionsParams<T>) {
  return useMemo(
    () =>
      !disableSort
        ? uniqBy([...options, ...addedOptions], displayValue).sort(sortFn)
        : uniqBy([...options, ...addedOptions], displayValue),
    [disableSort, options, addedOptions, displayValue, sortFn],
  );
}
